'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propsMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOADING = 'false';
var TOTAL = '0';
var PAGE = '1';
var PAGESIZE = '10';
var DATA = '[]';

var propsMap = (_propsMap = {}, (0, _defineProperty3.default)(_propsMap, LOADING, 'total'), (0, _defineProperty3.default)(_propsMap, TOTAL, 'total'), (0, _defineProperty3.default)(_propsMap, PAGE, 'page'), (0, _defineProperty3.default)(_propsMap, PAGESIZE, 'pageSize'), (0, _defineProperty3.default)(_propsMap, DATA, 'data'), _propsMap);

function getQuery(obj) {
  var dataPropName = propsMap[DATA];
  return Array.isArray(obj[dataPropName]) ? obj : null;
}
function updateQuery(obj, increment) {
  obj[propsMap[TOTAL]] = obj[propsMap[TOTAL]] + increment;
  obj[propsMap[LOADING]] = false;
  if (increment) {
    if (obj[propsMap[DATA]].length > obj[propsMap[PAGESIZE]]) {
      obj[propsMap[DATA]].pop();
      while (obj[propsMap[DATA]].length > obj[propsMap[PAGESIZE]]) {
        obj[propsMap[DATA]].pop();
      }
      obj[propsMap[PAGE]] = obj[propsMap[PAGE]] + 1;
    }
  }
}

function append(currentState, state, action, byMerge) {
  var query = getQuery(currentState);
  if (query) {
    currentState = currentState[propsMap[DATA]];
  }

  if (Array.isArray(currentState)) {
    if (byMerge && action.cid) {
      var map = {};
      if (Array.isArray(state)) {
        state.forEach(function (d) {
          return map[d[action.cid]] = d;
        });
      } else {
        map[state[action.cid]] = state;
      }
      currentState = currentState.map(function (d) {
        if (map[d[action.cid]]) {
          d = Object.assign(d, map[d[action.cid]]);
          delete map[d[action.cid]];
          return d;
        } else {
          return d;
        }
      });
    } else {
      if (Array.isArray(state)) {
        state.forEach(function (d) {
          if (query) {
            currentState.unshift(d);
            updateQuery(query, 1);
          } else {
            currentState.push(d);
          }
        });
      } else {
        if (query) {
          currentState.unshift(state);
          updateQuery(query, 1);
        } else {
          currentState.push(state);
        }
      }
    }
  } else {
    if (byMerge && action.cid) {
      currentState = Object.assign(currentState, state);
    }
  }
  return query || currentState;
}
function getState(payload, processData, action, pure) {
  var data = processData ? processData(payload.data) : payload.data;
  if (pure) {
    return data;
  } else {
    var state = void 0;
    if (Object(data) === data) {
      state = data;
    } else if (data) {
      state = payload.arguments[0];
    }
    return state;
  }
}

var crud = {
  console: {
    success: window.console.info,
    error: window.console.error
  },
  message: function message(sucMsg, errMsg) {
    return function (err) {
      if (err) {
        errMsg && crud.console.error(errMsg, err);
      } else {
        sucMsg && crud.console.success(sucMsg);
      }
    };
  },

  item: {},
  _itemsEntry: {
    data: [],
    loading: false,
    total: 0,
    pageSize: 10,
    page: 1
  },
  get itemsEntry() {
    return crud._itemsEntry;
  },
  set itemsEntry(itemsEntry) {
    crud._itemsEntry = itemsEntry;
    Object.keys(itemsEntry).forEach(function (key) {
      propsMap[itemsEntry[key].valueOf()] = key;
    });
  },
  list: [],
  noop: function noop() {},
  reset: function reset(nextState, payload, initialState) {
    return initialState;
  },
  forceUpdate: function forceUpdate(nextState) {
    nextState.forceUpdate && nextState.forceUpdate();
    return nextState;
  },
  create: function create(nextState, payload, initialState, currentState, action) {
    var state = getState(payload, action.processData, action);
    if (state) {
      if (parseInt(payload.data, 10)) {
        state[action.cid || 'id'] = payload.data;
      }
      return append(currentState, state, action);
    } else {
      return currentState;
    }
  },
  update: function update(nextState, payload, initialState, currentState, action) {
    var state = getState(payload, action.processData, action);

    if (state) {
      return append(currentState, state, action, true);
    } else {
      return currentState;
    }
  },
  delete: function _delete(nextState, payload, initialState, currentState, action) {
    var state = getState(payload, action.processData, action);
    var query = getQuery(currentState);
    if (query) {
      currentState = currentState[propsMap[DATA]];
    }
    if (action.cid) {
      var id = state[action.cid] + '';
      if (Array.isArray(currentState)) {
        var count = 0;
        currentState = currentState.filter(function (d) {
          if (id === String(d[action.cid])) {
            count++;
            return false;
          } else {
            return true;
          }
        });
        if (query && count) {
          query[propsMap[DATA]] = currentState;
          updateQuery(query, -count);
        }
      } else {
        if (id.indexOf(currentState[action.cid]) > -1) {
          currentState = initialState;
        }
      }
    }
    return query || currentState;
  },
  get: function get(nextState, payload, initialState, currentState, action) {
    return getState(payload, action.processData, action, true) || initialState;
  },
  query: function query(nextState, payload, initialState, currentState, action) {
    var data = action.processData ? action.processData(payload.data) : payload.data;
    if (Array.isArray(data)) {
      return {
        data: data,
        total: data.length,
        pageSize: 10,
        page: 1,
        loading: false
      };
    } else {
      return data || initialState;
    }
  }
};

exports.default = crud;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/damo/crud.js
// module id = 53
// module chunks = 0